// extracted by mini-css-extract-plugin
module.exports = {"root":"ExternalChannelsNotice_root__EEaYo"};